import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const ConfirmAccount = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Lien de confirmation invalide.');
      return;
    }

    confirmAccount(token);
  }, [searchParams]);

  const confirmAccount = async (token) => {
    try {
      const response = await fetch(`${API_URL}/auth/confirm-account`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage('Votre compte a été confirmé avec succès !');
        setEmail(data.email);
      } else {
        setStatus('error');
        setMessage(data.detail || 'Une erreur est survenue.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Erreur de connexion au serveur.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4">
            {status === 'loading' && (
              <Loader2 className="w-16 h-16 text-[#0F5156] animate-spin" />
            )}
            {status === 'success' && (
              <CheckCircle className="w-16 h-16 text-emerald-500" />
            )}
            {status === 'error' && (
              <XCircle className="w-16 h-16 text-red-500" />
            )}
          </div>
          <CardTitle className="text-2xl">
            {status === 'loading' && 'Confirmation en cours...'}
            {status === 'success' && 'Compte confirmé !'}
            {status === 'error' && 'Erreur de confirmation'}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <p className="text-slate-600">{message}</p>

          {status === 'success' && (
            <>
              <div className="bg-slate-50 rounded-lg p-4">
                <p className="text-sm text-slate-500">Vous pouvez maintenant vous connecter avec :</p>
                <p className="font-medium text-slate-900 mt-1">{email}</p>
              </div>
              <Button
                onClick={() => navigate('/login')}
                className="w-full bg-[#0F5156] hover:bg-[#0d464a]"
              >
                Se connecter
              </Button>
            </>
          )}

          {status === 'error' && (
            <div className="space-y-4">
              <p className="text-sm text-slate-500">
                Si le problème persiste, contactez votre administrateur.
              </p>
              <Button
                onClick={() => navigate('/login')}
                variant="outline"
                className="w-full"
              >
                Retour à la connexion
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ConfirmAccount;
